"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInfo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Dashboard view component
 * @return {Object}
 */
var TextInfo = function TextInfo(_ref) {
  var className = _ref.className,
    copy = _ref.copy,
    disabled = _ref.disabled,
    _ref$displayValue = _ref.displayValue,
    displayValue = _ref$displayValue === void 0 ? '' : _ref$displayValue,
    error = _ref.error,
    helpertext = _ref.helpertext,
    id = _ref.id,
    adornmentStart = _ref.adornmentStart,
    adornmentEnd = _ref.adornmentEnd,
    labelProps = _ref.labelProps,
    label = _ref.label,
    labelclassName = _ref.labelclassName,
    mask = _ref.mask,
    name = _ref.name,
    type = _ref.type,
    multiline = _ref.multiline,
    maxRows = _ref.maxRows,
    minRows = _ref.minRows,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
    _ref$onCopyClick = _ref.onCopyClick,
    onCopyClick = _ref$onCopyClick === void 0 ? function () {} : _ref$onCopyClick,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    dataTestId = _ref['data-testid'];
  var newDisplayValue = displayValue || value;
  var inputProps = {
    disabled: disabled,
    error: error,
    helpertext: helpertext,
    id: id,
    adornmentStart: adornmentStart,
    adornmentEnd: adornmentEnd,
    label: label,
    labelclassName: labelclassName,
    mask: mask,
    'data-testid': dataTestId
  };
  var inputRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    editing = _useState2[0],
    setEditing = _useState2[1];
  var labelClass = labelclassName || 'label';
  var customClass = "".concat(className, " form-control");
  var newValue = editing ? value : newDisplayValue;
  var iconProp = {};
  var newAdornmentStart = {};
  var newAdornmentEnd = {};
  if (adornmentStart) {
    newAdornmentStart = {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        className: className,
        position: "start"
      }, adornmentStart)
    };
  }
  if (adornmentEnd) {
    newAdornmentEnd = {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        className: className,
        position: "end"
      }, adornmentEnd)
    };
  }
  if (copy) {
    iconProp = {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
        "aria-label": "FilterNone",
        onClick: function onClick(e) {
          return onCopyClick(e);
        }
      }, /*#__PURE__*/_react["default"].createElement(_icons.FilterNone, null)))
    };
  }
  if (className) customClass += " ".concat(className);
  if (disabled) iconProp = {};
  if (mask) {
    return /*#__PURE__*/_react["default"].createElement(_reactInputMask["default"], {
      mask: mask,
      value: newValue || '',
      onFocus: function onFocus(e) {
        setEditing(true);
        _onFocus(e);
      },
      onBlur: function onBlur(e) {
        setEditing(false);
        _onBlur(e);
      },
      className: "".concat(className, " column form-control"),
      onChange: onChange,
      disabled: disabled
    }, function () {
      return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
        className: customClass,
        variant: "filled",
        error: error,
        editing: editing,
        value: newValue,
        disabled: disabled,
        endAdornment: !!adornmentEnd,
        displayValue: displayValue
      }, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        className: "form-group"
      }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, (0, _extends2["default"])({
        shrink: !!newValue || editing,
        className: labelClass,
        htmlFor: id
      }, _lodash["default"].omit(labelProps, 'className')), label), /*#__PURE__*/_react["default"].createElement(_core.FilledInput, (0, _extends2["default"])({
        inputRef: inputRef,
        inputProps: {
          className: className
        },
        name: name,
        type: type || 'text',
        multiline: multiline,
        maxRows: maxRows || 1,
        minRows: minRows || 1,
        title: label
      }, newAdornmentStart, newAdornmentEnd, iconProp, inputProps))), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, {
        className: "".concat(className, " helper-text")
      }, helpertext));
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_styles.Styled, {
    className: customClass,
    variant: "filled",
    error: error,
    editing: editing,
    value: newValue,
    disabled: disabled,
    endAdornment: !!adornmentEnd,
    displayValue: displayValue
  }, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, (0, _extends2["default"])({
    className: labelClass,
    htmlFor: id
  }, _lodash["default"].omit(labelProps, 'className')), label), /*#__PURE__*/_react["default"].createElement(_core.FilledInput, (0, _extends2["default"])({
    inputRef: inputRef,
    name: name,
    type: type || 'text',
    multiline: multiline,
    maxRows: maxRows || 1,
    minRows: minRows || 1,
    title: label,
    value: newValue || ''
  }, newAdornmentStart, newAdornmentEnd, iconProp, inputProps, {
    onFocus: function onFocus(e) {
      setEditing(true);
      _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setEditing(false);
      _onBlur(e);
    },
    onChange: onChange
  }))), /*#__PURE__*/_react["default"].createElement(_core.FormHelperText, {
    className: "helper-text"
  }, helpertext));
};
exports.TextInfo = TextInfo;